(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearDocumentosDossierDetailController",
            LebaniegoYearDocumentosDossierDetailController
        );

        LebaniegoYearDocumentosDossierDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearDocumentosDossier",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "LebaniegoYearDocumentosDossierFile",
        "$http",
        "Upload",
    ]

    function LebaniegoYearDocumentosDossierDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearDocumentosDossier,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        LebaniegoYearDocumentosDossierFile,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosDossier = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        LebaniegoYearDocumentosDossierFile.query(
            {
                id: vm.lebaniegoYearDocumentosDossier.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosDossier = Object.assign({}, vm.lebaniegoYearDocumentosDossier);

            LebaniegoYearDocumentosDossier.update(lebaniegoYearDocumentosDossier, onSaveSuccess, onError);
        }

        function updateDocument(document) {
            LebaniegoYearDocumentosDossierFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-documents-dossier-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearDocumentosDossierFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearDocumentosDossierFile.query(
                        {
                            id: vm.lebaniegoYearDocumentosDossier.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-documents-dossier-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyDocumentsDossierId: vm.lebaniegoYearDocumentosDossier.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearDocumentosDossierFile.query(
                            {
                                id: vm.lebaniegoYearDocumentosDossier.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();